export class TARIFF {
  /**
   *
   */
  constructor() {
    this.DEVICE_ID = 0;
    this.ENTRY_DATE_TIME = '';
    this.Exit_DATE_TIME = '';
    this.VALUE = 0;
    this.RATEPROFILE_ID = 0;
  }
  DEVICE_ID: number;
  ENTRY_DATE_TIME: string;
  Exit_DATE_TIME: string;
  VALUE: number;
  RATEPROFILE_ID: number;
}
